export function arrayEquals(a, b) {
    // console.log("arrayEquals::arrayEquals()");
    return a && b && a.length === b.length &&
        a.every((v, i) => {
            // console.log("v = '" + JSON.stringify(v) + "'");
            // console.log("b[i] = '" + JSON.stringify(b[i]) + "'");
            return JSON.stringify(v) === JSON.stringify(b[i])
        });
}